<script>
import {bank as bankColumns} from '../../../tables'
import pagination from "../../../config/pagination"

export default {
  props: {
    path: {
      type: String,
      default: null
    },
    viewOnly: {
      type: Boolean,
      default: false
    },
    routeName: {
      type: String,
      default: 'hyperion.finances.bank'
    }
  },
  computed: {
    columns() {
      let columns = bankColumns
      if (this.viewOnly)
        delete columns['action']
      return columns
    },
    pagination() {
      return {
        current: this.items.current_page,
        total: this.items.total,
        pageSize: this.pageSize,
        showSizeChanger: true
      }
    },
    pageSize() {
      return parseInt(this.items.per_page)
    },
    pathUrl() {
      return this.path === null
        ? this.routeUri('hyperion.finances.bank')
        : this.path
    },
  },
  data: () => ({
    loading: false,
    form: {},
    items: pagination,
    filters: {
      q: '',
      page: 1
    },
    editing: null,
    deleting: []
  }),
  created() {
    this.getItems()
  },

  methods: {
    updateUrl(record) {
      return this.pathUrl + '/' + record.hash
    },
    getItems() {
      this.$emit('filtered', this.filters)
      this.loading = true
      this.$http.get(this.pathUrl, {
        params: this.filters
      })
        .then((response) => this.items = response.data)
        .catch((error) => this.handleXhrError(error))
        .finally(() => this.loading = false)
    },
    tableChanged(pagination) {
      this.filters.page = pagination.current
      this.filters.per_page = pagination.pageSize
      this.pushState(this.filters)
      this.getItems()
    },
    onDeleteSuccess() {
      this.closeDrawer()
      this.$notification.success({
        message: 'Success',
        description: 'Data has been successfully deleted!',
        onClose: () => window.location.reload()
      })
    },
    filtered() {
      this.$emit('filtered', this.filters)
    },
    destroy(record) {
      this.deleting.push(record.hash)
      this.$http.delete(this.updateUrl(record))
        .then((r) => this.onDeleteSuccess())
        .catch((e) => this.handleXhrError(e));
    },
    edit(record) {
      this.editing = record
    }
  }
}
</script>
<template>
  <div>
    <a-card type="inner" size="small">
      <a-skeleton :loading="loading" active>
        <a-table :columns="columns" :dataSource="items.data" rowKey="id" :pagination="pagination" @change="tableChanged">
          <h5 slot="datetime" slot-scope="datetime" class="text-center">
            {{ moment(datetime).format('DD/MM/YYYY HH:mm:ss') }}
          </h5>

          <h5 slot="bank" slot-scope="record">
            <a-icon type="bank" /> <a :href="routeUri(routeName + '.mutation', { 'bank_hash' : record.hash })"><strong>[{{ record.bank_code }}] {{ record.bank_name }}</strong></a>
            <br>
            <a-icon type="safety-certificate" /> <code>{{ record.bank_swift }}</code>
          </h5>

          <h5 slot="account" slot-scope="record">
            <a-icon type="contacts" /> <strong>{{ record.account_holder }}</strong>
            <br>
            <a-icon type="number" /> <code>{{ record.account_number }}</code>
            <br>
            <a-icon type="global" /> <code>{{ record.branch_name }}</code>
          </h5>

          <h5 slot="balance" slot-scope="record" class="text-center">
            <currency :amount="record.balance" />
          </h5>

          <div slot="action" slot-scope="record">
            <template v-if="record.bank_code !== '000'">
              <a-popconfirm
                title="This will delete bank, all transactions record will not be available, are you sure?"
                @confirm="() => destroy(record)">
                <a-button :loading="deleting.includes(record.hash)" type="danger" size="small" icon="delete" />
              </a-popconfirm>

              <a-button size="small" type="primary" icon="edit" @click="() => edit(record)"  />
            </template>

            <a-button size="small" icon="ellipsis" :href="routeUri(routeName + '.mutation', {bank_hash: record.hash })" />
          </div>
        </a-table>
      </a-skeleton>
    </a-card>

    <a-drawer :width="720" placement="right" :closable="true" :visible="editing !== null" @close="() => editing = null">
      <template v-if="editing !== null && ! viewOnly">
        <h-bank-form :bank="editing" @success="() => editing = null" />
      </template>
    </a-drawer>
  </div>
</template>

